import { useEffect } from "react";
import { useHistory } from "react-router";

const ScrollRestoration = () => {

    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual"
        }
    }, []);

    return <></>;
};

export default ScrollRestoration;